import { Box, Button, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { NavItem } from './NavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Nav = function Nav(_ref) {
  var _data$subMenus;

  var data = _ref.data,
      showSideBar = _ref.showSideBar,
      activeColor = _ref.activeColor;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useRouter = useRouter(),
      push = _useRouter.push,
      asPath = _useRouter.asPath;

  return /*#__PURE__*/_jsxs(Popover, {
    trigger: "hover",
    placement: "right-start",
    closeDelay: 200,
    strategy: "fixed",
    e2eid: "ShellWithGroupedMenu_Nav_Popover",
    children: [/*#__PURE__*/_jsx(PopoverTrigger, {
      e2eid: "ShellWithGroupedMenu_Nav_PopoverTrigger",
      children: /*#__PURE__*/_jsx(Box, {
        tabIndex: 0,
        _focus: {
          outline: 'none'
        },
        e2eid: "ShellWithGroupedMenu_Nav_Box",
        children: /*#__PURE__*/_jsx(NavItem, {
          activeColor: activeColor,
          showSideBar: showSideBar,
          config: data,
          label: t(data === null || data === void 0 ? void 0 : data.i18n, data === null || data === void 0 ? void 0 : data.title),
          e2eid: "ShellWithGroupedMenu_Nav_NavItem"
        })
      })
    }), /*#__PURE__*/_jsx(PopoverContent, {
      overflow: "hidden",
      p: 0,
      outline: "none",
      width: "auto",
      e2eid: "ShellWithGroupedMenu_Nav_PopoverContent",
      children: data === null || data === void 0 ? void 0 : (_data$subMenus = data.subMenus) === null || _data$subMenus === void 0 ? void 0 : _data$subMenus.map(function (nav) {
        var active = nav.link === asPath;
        var activeTextColor = active ? 'white' : 'blackAlpha.300';
        var activeBgColor = active ? 'brand' : 'inherit';
        return /*#__PURE__*/_jsx(Button, {
          rounded: 0,
          onClick: function onClick() {
            push(nav.link || nav.id);
          },
          cursor: "pointer",
          _hover: {
            bg: active ? 'brand' : 'gray.50',
            textColor: activeTextColor
          },
          _active: {
            bg: activeBgColor,
            textColor: activeTextColor
          },
          textColor: activeTextColor,
          bgColor: activeBgColor,
          fontSize: "16px",
          fontWeight: "normal",
          textAlign: "left",
          h: "47px",
          justifyContent: "flex-start",
          e2eid: "ShellWithGroupedMenu_Nav_Button",
          children: t(nav === null || nav === void 0 ? void 0 : nav.i18n, nav.title)
        }, nav.link);
      })
    })]
  });
};